// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__sHa2K","approved":"Status_approved__1ZiJL","rejected":"Status_rejected__1h8cE","expired":"Status_expired__1ELCp","label":"Status_label__-redw"};